/* eslint-disable */
import { BehaviorSubject, of } from 'rxjs';
import { combineEpics } from 'redux-observable';
import { catchError, mergeMap } from 'rxjs/operators';
import spaces from 'spaces/store/epics';
import users from 'auth/store/users/epics';
import roles from 'auth/store/roles/epics';
import permissions from 'auth/store/permissions/epics';
import globalPermissions from 'auth/store/globalPermissions/epics';
import auth from 'auth/store/auth/epics';
import audit from 'auth/store/audit/epics';
import tags from 'documents/store/tags/epics';
import folders from 'documents/store/folders/epics';
import mailingLists from 'documents/store/mailinglists/epics';
import documents from 'documents/store/documents/epics';
import { epic as feeds } from '../feeds';
import {
  myDashboardEpics as myDashboard,
  defaultDashboardsEpics as defaultDashboards,
} from '../dashboard';
import { epic as contacts } from '../contacts';
import errors from 'base/errors/store/epics';
import { handleError } from 'base/errors/store/actions';
import {
  favoritesEpics as favorites,
  defaultFavoritesEpics as defaultFavorites,
} from '../favorites';
import { epics as news } from '../news';
import { epics as search } from '../search';
import { epics as trash } from '../trash';
import { epics as offline } from '../offline';


const epic$ = new BehaviorSubject(combineEpics(
  auth,
  spaces,
  folders,
  tags,
  documents,
  users,
  roles,
  feeds,
  myDashboard,
  defaultDashboards,
  permissions,
  contacts,
  favorites,
  defaultFavorites,
  errors,
  news,
  audit,
  search,
  trash,
  offline,
  mailingLists,
  globalPermissions,
));
const rootEpic = (action$, state$) => epic$.pipe(mergeMap(epic =>
  epic(action$, state$)
    .pipe(catchError((e) => {
      console.error('Uncaught epic', e.message); // eslint-disable-line
      return epic(of(handleError(e)), state$);
    }))));

export default rootEpic;
